import { LogData } from "@rogoag/shared-ts/dist/logger";
import { API } from "../../../api";
import type { Job, JobReady } from "../../../models";
import { applyCollectBoundary } from "../../../api/routers/data/tables/jobs";
import { logger } from "../../../utilities/logger";
import { toast } from "react-toastify";
import { User } from "../../../models";

export async function submitJobReadyForm(selectedJobs: Job[], user?: User): Promise<void> {
	if (selectedJobs) {
		if (selectedJobs.length > 0) {
			const jobsIds = selectedJobs.filter((j) => !!j).map((job) => job.id);
			const logData: LogData = {
				function: "MarkJobReadyPage.model.submitJobReadyForm",
				airtable_record_id: jobsIds.join(","),
				airtable_table: "Jobs",
			};
			logger.log("Submitting Job Ready form", logData);
			const jobReadyForm: Partial<JobReady> = {
				name: "",
				jobIds: jobsIds,
				submitter: user?.name ?? "",
			} as const;

			for (let i = 0; i < selectedJobs.length; i++) {
				// need to test this
				const job = selectedJobs[i];
				if (job?.isMarkedReady) {
					const ld = { ...logData };
					ld.airtable_record_id = job.id;
					logger.warning(
						`Job ${job.id} already marked as ready, but an additional Job Ready form is being attached`,
						ld,
					);
				}
			}

			await API.Data.JobsReady.create.one(jobReadyForm);
			logger.log("Job Ready form submitted successfully", logData);

			for (const job of selectedJobs) {
				applyCollectBoundary(job);
			}

			await API.Data.Jobs.update.many(selectedJobs, true);
			logger.log("Jobs updated successfully after marking as ready", logData);
		} else {
			toast.error("No jobs selected to mark as ready");
			throw new Error(`selectedJobs.length == 0`);
		}
	} else {
		toast.error("No jobs selected to mark as ready");
		throw new Error(`selectedJobs == undefined`);
	}
}
